import {
  getReportsData,
  getReportsTemplateData,
  createreports,
  getReportsWithTemplate,
  updatereports,
  getreports,
  deletereports,
} from "@/http/system/manageReport.js";

export default {
  namespaced: true,
  state: {
    reportList: [],
    CreateViewReportTemplate: {},
    CreateReportTemplate: null,
    viewReportTemplate: [],
    ViewReport: {},
  },
  actions: {
    async setReportsData({ commit }) {
      try {
        const resp = await getReportsData();
        commit("SET_REPORT_LIST", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setReportsTemplateData({ commit }) {
      try {
        const resp = await getReportsTemplateData();
        commit("SET_CREATE_REPORT_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createreportsAction({ commit }, data) {
      try {
        const resp = await createreports(data);
        commit("CREATE_REPORTS_ACTION", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setReportsWithTemplate({ commit }, id) {
      try {
        const resp = await getReportsWithTemplate(id);
        commit("SET_REPORTS_WITH_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updatereportsAction({ commit }, data) {
      try {
        return await updatereports(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setreports({ commit }, id) {
      try {
        const resp = await getreports(id);
        commit("SET_REPORTS", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deletereportsAction({ commit }, data) {
      try {
        return await deletereports(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_REPORT_LIST(state, payload) {
      state.reportList = payload;
    },
    SET_CREATE_REPORT_LIST(state, payload) {
      state.CreateViewReportTemplate = payload;
    },
    CREATE_REPORTS_ACTION(state, payload) {
      state.CreateReportTemplate = payload;
    },
    SET_REPORTS_WITH_TEMPLATE(state, payload) {
      state.viewReportTemplate = payload;
    },
    SET_REPORTS(state, payload) {
      state.ViewReport = payload;
    },
  },
  getters: {
    getReportListDataList(state) {
      return state.reportList;
    },
    savereportsResponse(state) {
      return state.CreateReportTemplate;
    },
  },
};
